import { UPDATED_NAM_COMMISSION_ANNOUNCEMENT_230414 } from "@faire/web-api--source/indigofair/settings/UPDATED_NAM_COMMISSION_ANNOUNCEMENT_230414";

import { getSettingValueAndAssign } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingUpdatedNAMCommissionAnnouncement = (): boolean =>
  getSettingValueAndAssign(UPDATED_NAM_COMMISSION_ANNOUNCEMENT_230414, false);
